/**
 * scanScheduleApi.ts - planification automatique des scans (Business+).
 *
 * GET  /api/clients/scan-schedule          (tous roles)
 * POST /api/clients/scan-schedule          (admin + auditor, plan Business+)
 * GET  /api/clients/scan-schedule/history  (tous roles)
 */
import { apiFetch } from './apiClient';
import type { ScanScopeProduct } from './scanScopeApi';

export type ScanScheduleFrequency = 'daily' | 'weekly' | 'monthly';
export type ScanScheduleScopeMode = 'inherit' | 'custom';

export interface ScanTypes {
  m365:  boolean;
  azure: boolean;
}

export interface ScanSchedule {
  enabled:             boolean;
  frequency:           ScanScheduleFrequency;
  dayOfWeek:           number;
  dayOfMonth:          number;
  hourUtc:             number;
  scopeMode:           ScanScheduleScopeMode;
  excludedProducts:    ScanScopeProduct[];
  scanTypes:           ScanTypes;
  lastScheduledScanAt: string | null;
  lastScheduledScanId: string | null;
  nextRunAt?:          string | null;
  planAllowed?:        boolean;
  currentPlan?:        string;
  updatedAt?:          string;
  updatedBy?:          string;
}

export interface ScanScheduleHistoryItem {
  id:           string;
  type:         'm365' | 'azure';
  source:       'scheduled' | 'manual';
  startedAt:    string;
  finishedAt?:  string | null;
  status:       string;
  score?:       number | null;
  label:        string;
  connectionId?: string;
  detailHref:   string;
}

export interface ScanScheduleHistoryResponse {
  items: ScanScheduleHistoryItem[];
  total: number;
  days:  number;
}

export const scanScheduleApi = {
  get:    () => apiFetch<ScanSchedule>('/clients/scan-schedule'),
  update: (sched: Partial<ScanSchedule>) =>
    apiFetch<ScanSchedule>('/clients/scan-schedule', {
      method: 'POST',
      body:   JSON.stringify(sched),
      headers: { 'Content-Type': 'application/json' },
    }),
  history: (days = 30) =>
    apiFetch<ScanScheduleHistoryResponse>(`/clients/scan-schedule/history?days=${days}`),
};
